export default __webpack_public_path__ + "static/media/error-chip.24eff720.svg";